import User from 'requests/objects/user'
import Base from 'requests/objects/_base'
import ExportStatus from 'requests/objects/exportStatus'
import Collaborator from 'requests/objects/collaborator'

/**
 * Export Object
 */
export default class Export extends Base {
    /**
     * @param {object} data data
     * @param {number=} data.exportId exportId
     * @param {number=} data.rubricExportId rubricExportId
     * @param {object=} data.rubricExport rubricExport
     * @param {number=} data.timeExportId timeExportId
     * @param {object=} data.timeExport timeExport
     * @param {number=} data.createdById createdById
     * @param {object=} data.createdBy createdBy
     * @param {object[]=} data.collaborators collaborators
     * @param {string=} data.company company
     * @param {Date=} data.startDate startDate
     * @param {Date=} data.endDate endDate
     * @param {Date=} data.rubricStartDate rubricStartDate
     * @param {Date=} data.rubricEndDate rubricEndDate
     * @param {Date=} data.timeStartDate timeStartDate
     * @param {Date=} data.timeEndDate timeEndDate
     */
    constructor({
        exportId,
        rubricExportId,
        rubricExport,
        timeExportId,
        timeExport,
        createdById,
        createdBy,
        collaborators,
        company,
        startDate,
        endDate,
        rubricStartDate,
        rubricEndDate,
        timeStartDate,
        timeEndDate,
        ...data
    } = {}) {
        super(data)
        this.exportId = exportId
        this.rubricExportId = rubricExportId
        this.rubricExport = rubricExport ? new ExportStatus(rubricExport) : null
        this.timeExportId = timeExportId
        this.timeExport = timeExport ? new ExportStatus(timeExport) : null
        this.createdById = createdById
        this.createdBy = createdBy ? new User(createdBy) : null
        this.collaborators = collaborators ? collaborators.map(x => new Collaborator(x)) : []
        this.company = company
        this.startDate = startDate ? new Date(startDate) : undefined
        this.endDate = endDate ? new Date(endDate) : undefined
        this.rubricStartDate = rubricStartDate ? new Date(rubricStartDate) : undefined
        this.rubricEndDate = rubricEndDate ? new Date(rubricEndDate) : undefined
        this.timeStartDate = timeStartDate ? new Date(timeStartDate) : undefined
        this.timeEndDate = timeEndDate ? new Date(timeEndDate) : undefined
    }
}
